<div class="tabs">
  <ng-container  *ngFor="let tab of tabs">
  <div
    class="tabs_item"
    [routerLink]="['../', tab.name.toLowerCase()]"
    routerLinkActive="tabs_item--active"
  >  
   {{ tab.name | humanizeCamelCase }} <span *ngIf="tab?.amount == 0 || tab?.amount">({{ tab?.amount }})</span>
  </div>
</ng-container>
</div>
<div class="action d-flex align-items-center">
  <div *ngIf="isShipmentList">
    <mat-slide-toggle
      class="mat-slide-toggle-sm me-2 mb-2"
      [labelPosition]="'before'"
      [(ngModel)]="isTable"
      (change)="changeToggle($event)">
      <span style="font-family: var(--font-primary)">Show Table View</span>
      </mat-slide-toggle> 
  </div>
  <div class="export-btn" *ngIf="exportMenu && !isTable">
    <div
        class="box_action"
        (click)="cancelPropergation($event)"
        [matMenuTriggerFor]="exportMenu"
      >
      <span>
        <app-button [ngClass]="{'mat-menu-action' : showUploadBulk}" [buttonSize]="'small'">
          Export
        </app-button>
      </span>
      </div>
  </div>
  <div *ngIf="actionText">
    <app-button [ngClass]="{'mat-menu-action' : showUploadBulk}" (click)="actionClicked()" [buttonSize]="'small'">{{
      actionText
    }}</app-button>
  </div>
  <div [matMenuTriggerFor]="menu" *ngIf="showUploadBulk">
    <app-button class="mat-menu-dropdown" [buttonSize]="'small'"
      > <i class="fal fa-chevron-down"></i
    ></app-button>
  </div>
  <mat-menu class="menu mat-custom-dropdown" #menu="matMenu">
    <button
      mat-menu-item
      class="menu_button"
      (click)="uploadBulkEvent.next(null)"
    >
     Bulk Create PO's
    </button>
  </mat-menu>
</div>
